/**
 * Checks that a list written by hand holds every member of a string union, once each.
 *
 * ```ts
 * export const CAMPAIGN_STATES = exhaustive<CampaignState>()(['Archived', 'Draft', 'Published', 'Deleted']);
 * ```
 */

// `unknown` while the list is fine, so the `&` below adds nothing. A string once it is not, and no
// array can be a string – that is how the mistake surfaces.
type MissingMembers<T extends string, U extends readonly string[]> =
	[Exclude<T, U[number]>] extends [never] ? unknown : `exhaustive: missing member ${Exclude<T, U[number]>}`;

type DuplicateMembers<U extends readonly string[]> =
	U extends readonly [infer Head extends string, ...infer Rest extends readonly string[]]
		? Head extends Rest[number] ? `exhaustive: duplicate member ${Head}` : DuplicateMembers<Rest>
		: unknown;

export const exhaustive = <T extends string>() =>
	<const U extends readonly T[]>(members: U & MissingMembers<T, U> & DuplicateMembers<U>): U => members;
